// extracted by mini-css-extract-plugin
export default {"root":"CardShimmer_root__c9wRh","content":"CardShimmer_content__QkRy1","header":"CardShimmer_header__FVlbV"};